/**
 * "Inför nästa övningstenta ska jag …" (pedagogy spec §7.3.8): one line of plan,
 * capped at `PLAN_MAX_LENGTH`, shown again when the next exam starts.
 * Ctrl/Cmd+Enter saves, like every textarea in the app (`onSubmitShortcut`).
 *
 * `latest` is false on a result that is not the user's most recently graded
 * session: `latestPlanForUser` only ever shows the newest one at the next
 * exam, so an older result's card must not promise to be shown there (Task
 * W11). The textarea stays editable and the one save is unchanged either way.
 */
import { PLAN_MAX_LENGTH } from "@shared/examWrapper";
import { Card, Textarea } from "@client/components/ui";
import { useT } from "@client/i18n";

export interface PlanLineCardProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  latest: boolean;
}

export function PlanLineCard({ value, onChange, onSubmit, latest }: PlanLineCardProps) {
  const t = useT();
  return (
    <Card>
      <Textarea
        label={t(latest ? "exam.wrapper.plan.label" : "exam.wrapper.plan.labelOlder")}
        placeholder={t("exam.wrapper.plan.placeholder")}
        hint={t(latest ? "exam.wrapper.plan.note" : "exam.wrapper.plan.noteOlder")}
        maxLength={PLAN_MAX_LENGTH}
        rows={3}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onSubmitShortcut={onSubmit}
      />
      <p className="mt-1 text-right text-xs tabular-nums text-ink-600 dark:text-ink-400">
        {t("exam.wrapper.plan.count", { used: value.length, max: PLAN_MAX_LENGTH })}
      </p>
    </Card>
  );
}
